export function getRoleColor(role) {
  switch (role) {
    case "Super Admin":
      return "red";
    case "Admin":
      return "#1E90FF";
    case "Therapist":
      return "#32CD32";
    case "Support Staff":
      return "#FFA500";
    case "Admission staff":
      return "#c729e9";
    case "Medical Staff":
      return "#4B0082";
    case "Hospitality Staff":
      return "#F08080";
    default:
      return "#808080";
  }
}
